import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

export const URL_REDUCER_REGEX = /\(overlay:.*/;

@Component({
  selector: 'epc-main-overlay',
  templateUrl: './main-overlay.component.html',
  styleUrls: ['./main-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MainOverlayComponent implements OnInit, OnDestroy {
  /** Indicates if the overlay wrapping the router outlet for the auxiliary route should be shown */
  @HostBinding('class.show')
  public show = false;

  private destroy$ = new Subject<void>();

  private activationUrl: string;

  private urlWithoutOverlay(url: string) {
    return url?.replace(URL_REDUCER_REGEX, '');
  }

  /**
   * Enables showing the overlay when the overlay outlet is activated
   */
  public onActivate() {
    document.body.style.overflow = 'hidden';
    this.show = true;
    this.activationUrl = this.urlWithoutOverlay(
      this.router.routerState.snapshot.url,
    );
  }

  /**
   * Hides the overlay when the overlay outlet is deactivated
   */
  public onDeactivate() {
    this.show = false;
    document.body.style.overflow = '';
  }

  constructor(private router: Router) {}

  public ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => this.show && event instanceof NavigationEnd),
        map((event: NavigationEnd) => this.urlWithoutOverlay(event.url)),
        takeUntil(this.destroy$),
      )
      .subscribe((targetUrl) => {
        if (targetUrl !== this.activationUrl) {
          this.close();
        }
      });
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private close() {
    this.router.navigate([{ outlets: { overlay: null } }]);
  }
}
